<template>
  <div>
    <div class="col-md-12">
      <app-note
        class="mb-primary"
        title="Información"
        content-type="html"
        :notes="[
          'Si se considera que los hallazgos de la evaluación documental comprometen la competencia técnica y la operación del OEC, el informe de evaluación documental debe señalar en su sección pertinente que no procede la evaluación in situ, identificando claramente las No Conformidades que sustentan dicha conclusión y finalizará el trámite. Si el OEC está interesado en iniciar un nuevo proceso, deberá ingresar una nueva solicitud de acreditación con el pago respectivo.',
        ]"
      />
    </div>
    <scopes-evaluator-tablee :activity="activity" v-if="activity" />
    
    <hr />

    <sampling-evaluator-sam-indexx
      :activity="activity"
      :acc-app-id="accAppId"
      :status="status"
      v-if="activity && ['OENY'].includes(activity)"
    />
  </div>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
export default {
  mixins: [FormMixin],
  data() {
    return {};
  },
  computed: {
    activity() {
      return this.$store.state.accreditation.app != null
        ? this.$store.state.accreditation.app.accreditation_activity.code
        : null;
    },
    accAppId() {
      return this.$store.state.accreditation.app != null
        ? this.$store.state.accreditation.app.id
        : null;
    },
    status() {
      let statusId = this.$store.state.accreditation.app ? this.$store.state.accreditation.app.status.id : null;
      if (statusId != 43) statusId = this.$store.state.evaluatorReview.evalTest.status;
      return statusId;
    },
  },
};
</script>
